<template>
  <!--  小程序端相关的视频-->
  <div>
    <div class="icon-group">
      <el-tooltip content="音频" :offset="0" effect="light">
        <img
          src="@/assets/icons/recording/recording.png"
          alt=""
          @click="showAudio = true"
        >
      </el-tooltip>
      <el-tooltip content="视频录像" :offset="0" effect="light">
        <img
          src="@/assets/icons/recording/video.png"
          alt=""
          @click="showCarVideo=true"
        >
      </el-tooltip>
    </div>
    <div class="video-group">
      <audio-show
        v-if="showAudio"
        class="record-audio"
        :show-audio="showAudio"
        @closeDialog="showAudio = false"
      />
      <camara-show
        v-if="showCarVideo"
        :video-button="showCarVideo"
        @closeDialog="showCarVideo = false"
      />
    </div>
  </div>
</template>

<script>
import "@assets/css/recording.scss";
import AudioShow from "./AudioShow.vue";
import CamaraShow from "./CamaraShow";

export default {
  name: "WechatRecording",
  components: {
    AudioShow,
    CamaraShow,
  },

  data() {
    return {
      showCarVideo: false,
      showAudio: false,
    };
  },
};
</script>
<style lang="scss" scoped>
.icon-group ::v-deep {
  img {
    width: 18px;
    height: 18px;
    vertical-align: middle;
    margin-left: 6px;
  }
}

::v-deep .select-video {
  position: relative;
  z-index: 9999;

  &:hover {
    opacity: .8;
    transition: opacity 1s;
  }

  .el-select {
    position: absolute;
    top: 0;
    z-index: 1000;
  }

  span {
    font-size: 16px;
    font-weight: bold;
    color: #999999;
  }
}

.video-group ::v-deep {
  .el-dialog__body {
    padding: 0;
    min-height: 360px;
  }
}

.record-audio ::v-deep {
  .el-button {
    font-size: 16px;
    color: #0C618B;
  }

  .el-dialog__body {
    padding: 24px;
  }
}
</style>
